export const EthL1BridgeGoerli = "0xc3511006C04EF1d78af4C8E0e74Ec18A6E64Ff9e";
export const EthL1BridgeMainnet = "0xae0Ee0A63A2cE6BaeEFFE56e7714FB4EFE48D419";
export const EthL2BridgeGoerli =
  "0x073314940630fd6dcda0d772d4c972c4e0a9946bef9dabf4ef84eda8ef542b82";
export const EthL2BridgeMainnet =
  "0x073314940630fd6dcda0d772d4c972c4e0a9946bef9dabf4ef84eda8ef542b82";
